<template>
  <div class="scroll-indicator">
    <svg viewBox="-105 0 512 512.00002" xmlns="http://www.w3.org/2000/svg">
      <path
        d="m150.601562 0c-83.042968 0-150.601562 67.558594-150.601562 150.601562v210.796876c0 83.042968 67.558594 150.601562 150.601562 150.601562 83.042969 0 150.601563-67.558594 150.601563-150.601562v-210.796876c0-83.042968-67.558594-150.601562-150.601563-150.601562zm119.882813 361.398438c0 66.101562-53.78125 119.882812-119.882813 119.882812-66.101562 0-119.882812-53.78125-119.882812-119.882812v-210.796876c0-66.101562 53.78125-119.882812 119.882812-119.882812 66.101563 0 119.882813 53.78125 119.882813 119.882812zm0 0"
      ></path>
      <path
        id="wheel"
        d="m150.605469 101.851562c-8.484375 0-15.359375 6.875-15.359375 15.359376v70.695312c0 8.480469 6.875 15.359375 15.359375 15.359375 8.480469 0 15.359375-6.878906 15.359375-15.359375v-70.695312c0-8.484376-6.875-15.359376-15.359375-15.359376zm0 0"
      ></path>
    </svg>
  </div>
</template>

<script>
export default {};
</script>

<style lang="scss">
.scroll-indicator {
  position: absolute;

  left: 0;
  right: 0;
  display: flex;
  align-items: center;
  justify-content: center;
  bottom: calc(80px + 30vh);
  svg {
    width: 40px;
    path {
      fill: #fff;
    }
    #wheel {
      animation: slide-in-top 1.2s cubic-bezier(0.25, 0.46, 0.45, 0.94) infinite
        both;
      @-webkit-keyframes slide-in-top {
        0% {
          transform: translateY(-2000px);
          opacity: 0;
        }
        100% {
          transform: translateY(0);
          opacity: 1;
        }
      }
      @keyframes slide-in-top {
        0% {
          transform: translateY(-1000px);
          opacity: 0;
        }
        100% {
          transform: translateY(0);
          opacity: 1;
        }
      }
    }
  }
}
</style>
